import script from "./card.vue?vue&type=script&setup=true&lang=ts"
export * from "./card.vue?vue&type=script&setup=true&lang=ts"

import "./card.vue?vue&type=style&index=0&id=4b4adc25&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b4adc25"]])

export default __exports__